import { createFileRoute } from '@tanstack/react-router';
import { ImportsRouteView } from '@/pages/workspaces/imports/routing';
import { LastWorkspaceResolver } from './-components';
import { validateNewImportSearch } from './-new-import-search';
import { NewImportPage } from './-route-pages';

/** No `appBundle`: this URL has no `journeys` segment for the resolver to rebuild from. */
function NewImportRoute() {
  return (
    <LastWorkspaceResolver>
      <ImportsRouteView>
        <NewImportPage />
      </ImportsRouteView>
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/imports/new')({
  validateSearch: validateNewImportSearch,
  component: NewImportRoute,
});
